export enum RoleKey {
  BIOLOGIC_ADMIN = 'biologic_admin',
  INSTITUTION_ADMIN = 'institution_admin',
  TRAINER_INSTITUTION = 'trainer_institution',
  TRAINER_BIOLOGIC = 'trainer_biologic',
  LEARNER = 'learner',
}
export enum TrainerRoleKey {
  PROVISIONAL_TRAINER = 'provisional_trainer',
  COACH_MANAGER = 'coach_manager',
  VOLUNTEER = 'volunteer',
  TRAIN_THE_TRAINER = 'train_the_trainer',
}
